import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { Key_subscriptionStatistics } from "../utils/constants";
import { getSubscriptionStatistics } from "../services/school/student/getSubscriptionStatistics";

export const useGetSubscriptionStatistics = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_subscriptionStatistics, JSON.stringify(data)],
    () => getSubscriptionStatistics(data),
    options?{...options}:{}
  );
